import '../scss/style.scss';
import Swiper from 'swiper';
import { Navigation, Pagination, Controller, EffectFade, Scrollbar, Mousewheel} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/effect-fade';

document.addEventListener('DOMContentLoaded', function () {

    const openNav = document.querySelector('.open-mobile');
    const closeNav = document.querySelector('.close-mobile');
    const navMain = document.querySelector('.nav-main');

    openNav.addEventListener('click', (e) => {
        e.preventDefault();
        navMain.classList.add('move-navigation');
    });

    closeNav.addEventListener('click', (e) => {
        e.preventDefault();
        navMain.classList.remove('move-navigation');
    });

    const accordionItems = document.querySelectorAll('.foo-acor');
    const accordionNav = document.querySelectorAll('.navigation-acor');

    accordionItems.forEach(item => {
        const toggleIcon = item.querySelector('i');
        const nextAcor = item.nextElementSibling;

        toggleIcon.addEventListener('click', () => {
            const isActive = toggleIcon.classList.contains('active');

            document.querySelectorAll('.next-acor').forEach(ul => {
                ul.classList.remove('!max-[680px]:flex');
                ul.classList.add('hidden');
            });
            document.querySelectorAll('.foo-acor i').forEach(icon => {
                icon.classList.remove('active');
                icon.style.transform = 'rotate(0deg)';
            });

            if (!isActive) {
                nextAcor.classList.remove('hidden');
                nextAcor.classList.add('!max-[680px]:flex');
                nextAcor.classList.remove('max-[680px]:hidden');
                toggleIcon.classList.add('active');
                toggleIcon.style.transform = 'rotate(180deg)';
            } else {
                nextAcor.classList.add('hidden');
                nextAcor.classList.remove('!max-[680px]:flex');
                nextAcor.classList.add('max-[680px]:hidden');
                toggleIcon.classList.remove('active');
                toggleIcon.style.transform = 'rotate(0deg)';
            }
        });
    });

    accordionNav.forEach(item2 => {
        const toggleIcon2 = item2.querySelector('i');
        const nextAcor2 = item2.nextElementSibling;

        toggleIcon2.addEventListener('click', () => {
            const isActive2 = toggleIcon2.classList.contains('active');

            document.querySelectorAll('.nextNavigation-acor').forEach(ul2 => {
                ul2.classList.remove('flex');
                ul2.classList.add('max-[1100px]:hidden');
            });
            document.querySelectorAll('.navigation-acor i').forEach(icon2 => {
                icon2.classList.remove('active');
                icon2.style.transform = 'rotate(0deg)';
            });

            if (!isActive2) {
                nextAcor2.classList.remove('max-[1100px]:hidden');
                nextAcor2.classList.add('flex');
                nextAcor2.classList.remove('max-[680px]:hidden');
                toggleIcon2.classList.add('active');
                toggleIcon2.style.transform = 'rotate(180deg)';
            } else {
                nextAcor2.classList.add('max-[1100px]:hidden');
                nextAcor2.classList.remove('flex');
                nextAcor2.classList.add('max-[680px]:hidden');
                toggleIcon2.classList.remove('active');
                toggleIcon2.style.transform = 'rotate(0deg)';
            }
        });
    });

    function createConfettiForSection(section, count, images) {
        const sectionWidth = section.offsetWidth;
        const sectionHeight = section.offsetHeight;
        const margin = 30;

        for (let i = 0; i < count; i++) {
            const confetti = document.createElement('div');
            confetti.classList.add('confetti');

            const randomImage = images[Math.floor(Math.random() * images.length)];
            confetti.style.backgroundImage = `url(${randomImage})`;

            // Asignar un tamaño aleatorio (10px a 30px)
            const size = Math.random() * 40 + 25;
            confetti.style.width = `${size}px`;
            confetti.style.height = `${size}px`;

            confetti.style.left = `${Math.random() * (sectionWidth - 2 * margin) + margin}px`;
            confetti.style.top = `${Math.random() * sectionHeight}px`;

            // Animaciones personalizadas
            confetti.style.animationDuration = `${5 + Math.random() * 5}s`;
            confetti.style.animationDelay = `${Math.random() * 2}s`;
            confetti.style.animationName = 'float, rotate';
            confetti.style.animationTimingFunction = 'ease-in-out, linear';

            section.appendChild(confetti);
        }
    }

    document.querySelectorAll('div[data-confetti][data-images]').forEach(section => {
        const count = parseInt(section.getAttribute('data-confetti'), 10) || 0;
        const images = section.getAttribute('data-images').split(',');

        if (images.length > 0) {
            createConfettiForSection(section, count, images);
        }
    });

    const searchLink = document.querySelector('.search-btn');
    const closeSearchLink = document.querySelector('.close-search');
    const shopParentBtn = document.querySelector('.shop-parent-btn');
    const modalSearch = document.querySelector('.modal-search');

    searchLink.addEventListener('click', (event) => {
        event.preventDefault();
        shopParentBtn.classList.add('hidden');
        shopParentBtn.classList.remove('flex');
        modalSearch.classList.remove('hidden');
        modalSearch.classList.add('block');
    });

    closeSearchLink.addEventListener('click', (event) => {
        event.preventDefault();
        shopParentBtn.classList.remove('hidden');
        shopParentBtn.classList.add('flex');
        modalSearch.classList.remove('block');
        modalSearch.classList.add('hidden');
    });

    function updateSlideStyles(swiper) {
        setTimeout(() => {
            swiper.slides.forEach((slide) => {
                const child = slide.querySelector('.item-child');
                if (child) {
                    child.style.backgroundColor = '';
                    child.style.color = '';
                }
            });

            const activeSlide = swiper.slides[swiper.activeIndex];

            if (!activeSlide || !activeSlide.classList.contains('swiper-slide-active')) {
                return;
            }

            const activeChild = activeSlide.querySelector('.item-child');
            if (!activeChild) {
                console.warn('El slide activo no tiene un elemento .item-child');
                return;
            }

            const newBgColor = activeSlide.dataset.color;
            const newTextColor = activeSlide.dataset.textColor;

            if (!newBgColor || !newTextColor) {
                console.warn(
                    `Faltan los atributos data-color o data-text-color en el slide activo`,
                    activeSlide
                );
                return;
            }

            activeChild.style.backgroundColor = newBgColor;
            activeChild.style.color = newTextColor;
        }, 10);
    }

    function enableClickNavigation(swiper) {
        swiper.slides.forEach((slide, index) => {
            slide.addEventListener('click', () => {
                swiper.slideTo(index);
            });
        });
    }

    var slider_1 = new Swiper('.slider-1', {
        modules: [Navigation],
        spaceBetween: 10,
        loop: true,
        navigation: {
            prevEl: '.swiper-slider-1-prevColors',
            nextEl: '.swiper-slider-1-nextColors',
        },
        /*on: {
            init: function () {
            updateSlideStyles(this);
            enableClickNavigation(this);
            },
            slideChange: function () {
            updateSlideStyles(this);
            },
        },*/
        breakpoints: {
            0: {
                slidesPerView: 2,
            },
            960: {
                slidesPerView: 3,
            }
        }
    });

    const sliders = [
        new Swiper('.slider-2', {
        modules: [Navigation],
            slidesPerView: 1,
            speed: 800,
            navigation: {
                nextEl: '.swiper-button-nextColors',
                prevEl: '.swiper-button-prevColors',
            },
            /*on: {
                init: function () {
                    const firstSlide = this.slides[this.activeIndex];
                    const initialBgColor = firstSlide.dataset.color;
                    const initialTextColor = firstSlide.dataset.textColor;

                    const container = document.querySelector('.slider-container');
                    const slider4Wrapper = document.querySelector('.slider-4 .swiper-wrapper');
                    const titleMain = document.querySelector('.title-main-h');

                    container.style.backgroundColor = initialBgColor;
                    slider4Wrapper.style.color = initialTextColor;
                    titleMain.style.color = initialTextColor;
                },
                slideChange: function () {
                    const activeSlide = this.slides[this.activeIndex];
                    const newBgColor = activeSlide.dataset.color;
                    const newTextColor = activeSlide.dataset.textColor;

                    const container = document.querySelector('.slider-container');
                    const slider4Wrapper = document.querySelector('.slider-4 .swiper-wrapper');
                    const titleMain = document.querySelector('.title-main-h');

                    container.style.backgroundColor = newBgColor;
                    slider4Wrapper.style.color = newTextColor;
                    titleMain.style.color = newTextColor;
                },
            },*/
        }),
        new Swiper('.slider-3', {
            slidesPerView: 3,
            spaceBetween: 15,
            centeredSlides: true,
            on: {
                init: function () {
                    enableClickNavigation(this);
                },
            },
        }),
        /*new Swiper('.slider-4', {
            slidesPerView: 1,
        }),*/
    ];

    sliders.forEach((swiper, swiperIndex) => {
        swiper.on('slideChange', () => {
            const currentIndex = swiper.realIndex;
            sliders.forEach((otherSwiper, otherIndex) => {
                if (swiperIndex !== otherIndex) {
                otherSwiper.slideTo(currentIndex);
                }
            });
        });
    });


    document.querySelectorAll(".parent-faqs").forEach(parent => {
        const title = parent.querySelector(".title");
        const content = parent.querySelector(".content-faqs");
        const icon = title.querySelector(".fa-solid");

        title.addEventListener("click", () => {
            const isOpen = !content.classList.contains("hidden");

            document.querySelectorAll(".parent-faqs").forEach(otherParent => {
                const otherContent = otherParent.querySelector(".content-faqs");
                const otherIcon = otherParent.querySelector(".title .fa-solid");

                if (otherParent !== parent) {
                    otherContent.classList.add("hidden");
                    otherContent.classList.remove("flex");
                    otherIcon.classList.add("fa-plus");
                    otherIcon.classList.remove("fa-minus");
                }
            });

            if (isOpen) {
                content.classList.add("hidden");
                content.classList.remove("flex");
                icon.classList.add("fa-plus");
                icon.classList.remove("fa-minus");
            } else {
                content.classList.remove("hidden");
                content.classList.add("flex");
                icon.classList.remove("fa-plus");
                icon.classList.add("fa-minus");
            }
        });
    });

    var swiperhistory = new Swiper('.slider-history', {
        modules: [Navigation],
        loop: true,
        spaceBetween: 17,
        slidesPerView: 1.8,
        navigation: {
            prevEl: '.swiper-history-prev',
            nextEl: '.swiper-history-next',
        },
        breakpoints: {
            0: {
                slidesPerView: 1.1,
            },
            680: {
                slidesPerView: 1.3,
            },
            960: {
                slidesPerView: 1.8,
            }
        }
    });

    var swiperMain = new Swiper('.slider-welcome', {
        modules: [Navigation, Pagination, EffectFade],
        effect: 'fade',
        fadeEffect: { crossFade: true },
        loop: true,
        slidesPerView: 1,
    });

    var swiperText = new Swiper('.slider-welcome-text', {
        modules: [Navigation, Pagination, EffectFade, Controller],
        effect: 'fade',
        fadeEffect: { crossFade: true },
        loop: true,
        slidesPerView: 1,
        controller: {
            control: swiperMain,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination-custom',
            clickable: true,
        }
    });

    var sliderProducts = new Swiper('.slider-products', {
        modules: [Navigation, Pagination, EffectFade],
        loop: true,
        navigation: {
            nextEl: '.swiper-button-nextP',
            prevEl: '.swiper-button-prevP',
        },
        pagination: {
            el: '.swiper-pagination-pro',
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 2,
                spaceBetween: 21
            },
            960: {
                slidesPerView: 3,
                spaceBetween: 36
            },
            1100: {
                slidesPerView: 4,
                spaceBetween: 21
            },
            1480: {
                slidesPerView: 4,
                spaceBetween: 36
            }
        }
    });

    var sliderProductsR = new Swiper('.slider-products-releated', {
        modules: [Navigation, Pagination, EffectFade],
        loop: true,
        navigation: {
            nextEl: '.swiper-button-nextPR',
            prevEl: '.swiper-button-prevPR',
        },
        pagination: {
            el: '.swiper-pagination-proR',
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 2,
                spaceBetween: 21
            },
            960: {
                slidesPerView: 3,
                spaceBetween: 36
            },
            1100: {
                slidesPerView: 4,
                spaceBetween: 21
            },
            1480: {
                slidesPerView: 4,
                spaceBetween: 36
            }
        }
    });

    var sliderscroll = new Swiper('.slider-scroll', {
        modules: [Navigation, Pagination, EffectFade, Scrollbar, Mousewheel],
        loop: false,
        slidesPerView: 4,
        spaceBetween: 16,
        navigation: {
            nextEl: '.swiper-button-nextSc',
            prevEl: '.swiper-button-prevSc',
        },
        mousewheel: {
            invert: false,
        },
        scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
            draggable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            680: {
                slidesPerView: 2,
            },
            960: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            }
        }
    });

    var sliderCardsG = new Swiper('.slider-cards-gold', {
        modules: [Navigation, Pagination, EffectFade],
        loop: true,
        slidesPerView: 3,
        spaceBetween: 36,
        navigation: {
            nextEl: '.swiper-button-nextCaG',
            prevEl: '.swiper-button-prevCaG',
        },
        pagination: {
            el: '.swiper-pagination-cards-gold',
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            680: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 3,
            }
        }
    });

    var sliderProductsF = new Swiper('.slider-featured-products', {
        modules: [Navigation, Pagination, EffectFade],
        loop: true,
        navigation: {
            nextEl: '.swiper-button-nextPF',
            prevEl: '.swiper-button-prevPF',
        },
        pagination: {
            el: '.swiper-pagination-proPF',
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 2,
                spaceBetween: 21
            },
            960: {
                slidesPerView: 3,
                spaceBetween: 36
            },
            1100: {
                slidesPerView: 4,
                spaceBetween: 21
            },
            1480: {
                slidesPerView: 4,
                spaceBetween: 36
            }
        }
    });

    document.querySelectorAll('[class*="slider-tabs-"]').forEach((slider, index) => {
        new Swiper(`.slider-tabs-${index + 1}`, {
            modules: [Navigation, Pagination, EffectFade],
            loop: true,
            slidesPerView: 4,
            spaceBetween: 36,
            navigation: {
                nextEl: `.swiper-button-nextT-${index + 1}`,
                prevEl: `.swiper-button-prevT-${index + 1}`,
            },
            pagination: {
                el: `.swiper-pagination-tabs-${index + 1}`,
                clickable: true,
            },
            breakpoints: {
                0: {
                    slidesPerView: 2,
                    spaceBetween: 21
                },
                960: {
                    slidesPerView: 3,
                    spaceBetween: 36
                },
                1200: {
                    slidesPerView: 4,
                }
            }
        });
    });

    /*var sliderTabsGold = new Swiper('.slider-tabs-gold', {
        modules: [Navigation, Pagination, EffectFade],
        loop: true,
        slidesPerView: 3,
        spaceBetween: 36,
        navigation: {
            nextEl: '.swiper-button-nextT',
            prevEl: '.swiper-button-prevT',
        },
        pagination: {
            el: '.swiper-pagination-tabs',
            clickable: true,
        }
    });*/

    // Seleccionar todos los contenedores de sliders
    const sliderTabsGold = document.querySelectorAll('.slider-tabs-gold');

    // Iterar sobre cada slider y inicializarlo
    sliderTabsGold.forEach((slider, index) => {
        const nextButton = slider.closest('.parent-gold').querySelector('.swiper-button-nextT');
        const prevButton = slider.closest('.parent-gold').querySelector('.swiper-button-prevT');

        new Swiper(slider, {
            modules: [Navigation, Pagination, EffectFade],
            loop: true,
            slidesPerView: 3,
            spaceBetween: 36,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                },
                680: {
                    slidesPerView: 2,
                },
                960: {
                    slidesPerView: 3,
                }
            }
        });
    });

    document.querySelectorAll('[class*="slider-cities-"]').forEach((slider, index) => {
        new Swiper(`.slider-cities-${index + 1}`, {
            modules: [Navigation, Pagination, EffectFade],
            loop: true,
            slidesPerView: 3,
            spaceBetween: 10,
            centeredSlides: true,
            navigation: {
                nextEl: `.swiper-button-nextC-${index + 1}`,
                prevEl: `.swiper-button-prevC-${index + 1}`,
            },
            pagination: {
                el: `.swiper-pagination-cities-${index + 1}`,
                clickable: true,
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                },
                960: {
                    slidesPerView: 3,
                }
            }
        });
    });

    document.querySelectorAll('.slider-kids').forEach((slider) => {
        const parent = slider.closest('.parent-kids');
        const nextButton = parent.querySelector('.swiper-button-nextK');
        const prevButton = parent.querySelector('.swiper-button-prevK');
        const pagination = parent.querySelector('.swiper-pagination-kids');

        const swiper = new Swiper(slider, {
            modules: [Navigation, Pagination, EffectFade],
            loop: true,
            slidesPerView: 3,
            spaceBetween: 0,
            speed: 500,
            centeredSlides: true,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
            pagination: {
                el: pagination,
                clickable: true,
            },
            on: {
                init: function () {
                    updateSlideClasses(this);
                },
                slideChange: function () {
                    updateSlideClasses(this);
                },
                transitionEnd: function () {
                    updateSlideClasses(this);
                },
            },
            breakpoints: {
                0: {
                    slidesPerView: 1.6,
                },
                380: {
                    slidesPerView: 1.5,
                },
                960: {
                    slidesPerView: 3,
                }
            }
        });

        function updateSlideClasses(swiperInstance) {
            const slides = swiperInstance.slides;
            const activeIndex = swiperInstance.activeIndex % slides.length;

            slides.forEach((slide) => {
                slide.classList.remove('swiper-slide-prev', 'swiper-slide-next');
            });

            for (let i = 0; i < slides.length; i++) {
                if (i < activeIndex) {
                    slides[i].classList.add('swiper-slide-prev');
                } else if (i > activeIndex) {
                    slides[i].classList.add('swiper-slide-next');
                }
            }
        }
    });

    var sliderProducts2 = new Swiper('.slider-products-type2', {
        modules: [Navigation, Pagination, EffectFade],
        loop: true,
        navigation: {
            nextEl: '.swiper-button-nextP',
            prevEl: '.swiper-button-prevP',
        },
        pagination: {
            el: '.swiper-pagination-pro-type2',
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 2,
                spaceBetween: 21
            },
            960: {
                slidesPerView: 3,
                spaceBetween: 36
            },
            1100: {
                slidesPerView: 4,
                spaceBetween: 21
            },
            1480: {
                slidesPerView: 4,
                spaceBetween: 36
            }
        }
    });

    var slidercolumns = new Swiper('.slider-columns', {
        modules: [Navigation, Pagination, EffectFade],
        loop: true,
        slidesPerView: 2,
        spaceBetween: 50,
        navigation: {
            nextEl: '.swiper-button-nextC',
            prevEl: '.swiper-button-prevC',
        },
        pagination: {
            el: '.swiper-pagination-cols',
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            960: {
                slidesPerView: 2,
            }
        }
    });

    var slidercolumns = new Swiper('.slider-columns-2', {
        modules: [Navigation, Pagination, EffectFade],
        loop: true,
        slidesPerView: 2,
        spaceBetween: 50,
        navigation: {
            nextEl: '.swiper-button-nextC2',
            prevEl: '.swiper-button-prevC2',
        },
        pagination: {
            el: '.swiper-pagination-cols2',
            clickable: true,
        },
        breakpoints: {
            0: {
                spaceBetween: 12,
            },
            960: {
                spaceBetween: 50,
            }
        }
    });

    var slidercolumns = new Swiper('.slider-columns-3', {
        modules: [Navigation, Pagination, EffectFade],
        loop: true,
        slidesPerView: 2,
        spaceBetween: 50,
        navigation: {
            nextEl: '.swiper-button-nextC3',
            prevEl: '.swiper-button-prevC3',
        },
        pagination: {
            el: '.swiper-pagination-cols3',
            clickable: true,
        },
        breakpoints: {
            0: {
                spaceBetween: 12,
            },
            960: {
                spaceBetween: 50,
            }
        }
    });

    var sliderworlds = new Swiper('.slider-worlds', {
        modules: [Navigation, Pagination, EffectFade],
        loop: true,
        slidesPerView: 1,
        spaceBetween: 50,
        navigation: {
            nextEl: '.swiper-button-nextW',
            prevEl: '.swiper-button-prevW',
        }
    });


    var sliderautowith = new Swiper('.slider-autowidth', {
        modules: [Navigation, Pagination, EffectFade],
        slidesPerView: "auto",
        spaceBetween: 40,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-nextW',
            prevEl: '.swiper-button-prevW',
        },
        pagination: {
            el: '.swiper-pagination-width',
            clickable: true,
        },
        breakpoints: {
            0: {
                spaceBetween: 20,
            },
            680: {
                spaceBetween: 40,
            }
        }
    });

    var slidersocialGold = new Swiper('.slider-social-gold', {
        modules: [Navigation, Pagination, EffectFade],
        slidesPerView: 3.5,
        spaceBetween: 40,
        loop: false,
        navigation: {
            nextEl: '.swiper-button-nextSo',
            prevEl: '.swiper-button-prevSo',
        },
        pagination: {
            el: '.swiper-pagination-social',
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            960: {
                slidesPerView: 2.5,
                spaceBetween: 30,
            },
            1200: {
                slidesPerView: 3.5,
                spaceBetween: 40,
            }
        }
    });

    var sliderBrands = new Swiper('.slider-brands', {
        modules: [Navigation, Pagination, EffectFade],
        loop: true,
        slidesPerView: 3,
        spaceBetween: 50,
        navigation: {
            nextEl: '.swiper-button-nextB',
            prevEl: '.swiper-button-prevB',
        },
        pagination: {
            el: '.swiper-pagination-brands',
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            960: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 3,
            }
        }
    });

    var sliderLinks = new Swiper('.slider-links', {
        modules: [Navigation, Pagination, EffectFade],
        loop: true,
        slidesPerView: 2,
        spaceBetween: 13,
        navigation: {
            nextEl: '.swiper-button-nextL',
            prevEl: '.swiper-button-prevL',
        }
    });

    var sliderBrands2 = new Swiper('.slider-brands-buttons', {
        modules: [Navigation, Pagination, EffectFade],
        loop: true,
        slidesPerView: 4,
        spaceBetween: 50,
        navigation: {
            nextEl: '.swiper-button-nextB2',
            prevEl: '.swiper-button-prevB2',
        },
        pagination: {
            el: '.swiper-pagination-brands2',
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            960: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 3,
            }
        }
    });

    var swiperJelly = new Swiper('.slider-jelly-image', {
        modules: [Navigation, Pagination, EffectFade],
        effect: 'fade',
        fadeEffect: { crossFade: true },
        loop: true,
        slidesPerView: 1,
    });

    var swiperJelly2 = new Swiper('.slider-jelly-image-type2', {
        modules: [Navigation, Pagination, EffectFade],
        effect: 'fade',
        fadeEffect: { crossFade: true },
        loop: true,
        slidesPerView: 1,
    });

    var swiperJText = new Swiper('.slider-jelly-text', {
        modules: [Navigation, Pagination, EffectFade, Controller],
        effect: 'fade',
        fadeEffect: { crossFade: true },
        loop: true,
        slidesPerView: 1,
        controller: {
            control: swiperJelly,
        },
        navigation: {
            nextEl: '.swiper-button-nextJ',
            prevEl: '.swiper-button-prevJ',
        },
        pagination: {
            el: '.swiper-pagination-jelly',
            clickable: true,
        },
    });

    var swiperJText2 = new Swiper('.slider-jelly-text-type2', {
        modules: [Navigation, Pagination, EffectFade, Controller],
        effect: 'fade',
        fadeEffect: { crossFade: true },
        loop: true,
        slidesPerView: 1,
        controller: {
            control: swiperJelly,
        },
        navigation: {
            nextEl: '.swiper-button-nextJ2',
            prevEl: '.swiper-button-prevJ2',
        },
        pagination: {
            el: '.swiper-pagination-jelly2',
            clickable: true,
        },
    });

    function updateActiveDotColor() {
        var allDots = document.querySelectorAll('.swiper-pagination-jelly .swiper-pagination-bullet');
        allDots.forEach(dot => {
            dot.style.removeProperty('background-color');
        });

        var activeSlide = swiperJText.slides[swiperJText.activeIndex];
        if (activeSlide) {
            var colorElement = activeSlide.querySelector('a[data-color]');
            if (colorElement) {
                var color = colorElement.getAttribute('data-color');
                var activeDot = document.querySelector('.swiper-pagination-jelly .swiper-pagination-bullet-active');
                if (activeDot) {
                    activeDot.style.setProperty('background-color', color, 'important');
                }
            }
        }
    }

    // Filtro Recetas
    if (document.getElementById('filter-form')) {
        const addButton = document.getElementById('add-ingredient-select');
        const referenceNode = addButton.closest('.col-span-4');
        const initialIngredientOptions = [...document.getElementById('ing').options];

        addButton.addEventListener('click', function () {
            const newSelectWrapper = document.createElement('div');
            newSelectWrapper.classList.add('relative', 'col-span-4', 'max-[680px]:col-span-12');

            const newSelect = document.createElement('select');
            newSelect.name = 'ing[]';
            newSelect.classList.add(
                'ingredient-select', 'appearance-none', 'h-[5rem]', 'border-[.2rem]', 'border-[#CCCCCC]',
                'rounded-[2.5rem]', 'outline-none', 'focus:ring-0', 'focus:!border-[#CCCCCC]',
                'overflow-auto', 'bg-transparent', 'bg-none', 'text-[1.5rem]', 'font-normal', 'text-[#292724]',
                'w-full', 'px-[1.8rem]', 'py-[1.4rem]'
            );

            const iconWrapper = document.createElement('div');
            iconWrapper.classList.add('absolute', 'right-0', 'top-0', 'bottom-0', 'my-auto', '-z-[1]', 'flex', 'items-center', 'px-[1.5rem]',
                'before:absolute', 'before:w-[.2rem]', 'before:h-[3.5rem]', 'before:bg-[#CCCCCC]', 'before:left-0');
            iconWrapper.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="w-[1.8rem]">
                <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" class="fill-[#D92A1C]"></path>
            </svg>
            `;

            populateSelectOptions(newSelect);
            newSelectWrapper.appendChild(newSelect);
            newSelectWrapper.appendChild(iconWrapper);

            referenceNode.parentNode.insertBefore(newSelectWrapper, referenceNode);

            updateIngredientOptions();
        });

        function populateSelectOptions(select) {
            select.innerHTML = '';
            const selectedValues = getSelectedValues();

            initialIngredientOptions.forEach(option => {
                if (!selectedValues.includes(option.value) || option.value === '') {
                    select.add(new Option(option.text, option.value));
                }
            });
        }

        function getSelectedValues() {
            return Array.from(document.querySelectorAll('select.ingredient-select'))
                .map(select => select.value)
                .filter(value => value !== '');
        }

        function updateIngredientOptions() {
            const selectedValues = getSelectedValues();
            const totalOptions = initialIngredientOptions.length - 1;
            const remainingOptions = totalOptions - selectedValues.length;
            const totalSelects = document.querySelectorAll('select.ingredient-select').length;

            document.querySelectorAll('select.ingredient-select').forEach(select => {
                const currentValue = select.value;
                populateSelectOptions(select);

                if (selectedValues.includes(currentValue)) {
                    select.value = currentValue;
                }
            });

            if (remainingOptions <= 1 || totalSelects >= totalOptions) {
                addButton.classList.add('opacity-50', 'cursor-not-allowed');
                addButton.disabled = true;
            } else {
                addButton.classList.remove('opacity-50', 'cursor-not-allowed');
                addButton.disabled = false;
            }
        }

        const form = document.getElementById('filter-form');
        const filterResults = document.getElementById('filter-results');

        form.addEventListener('submit', function (e) {
            e.preventDefault();
            const formData = new FormData(this);
            fetch(this.getAttribute('action'), {
                method: this.getAttribute('method'),
                body: formData
            })
            .then(response => {
                if (response.ok) {
                    return response.text();
                } else {
                    throw new Error('Error en la petición AJAX');
                }
            })
            .then(text => {
                filterResults.innerHTML = text;
                filterResults.classList.remove('hidden');
            })
            .catch(error => {
                console.error('Error:', error);
            });
        });
    }

    // Buscador AJAX
    const searchForm = document.getElementById("search-form");
    const searchInput = searchForm.querySelector("input[type='text']");
    const searchResults = document.getElementById("search-results");

    if (!searchForm || !searchInput || !searchResults) {
        return;
    }

    const ajaxUrl = searchForm.dataset.ajaxUrl;
    let debounceTimer;

    searchInput.addEventListener("input", function () {
        clearTimeout(debounceTimer);

        const query = searchInput.value;

        searchResults.style.display = "none";

        if (query.length > 2) {
            debounceTimer = setTimeout(() => {
                fetch(ajaxUrl + "?action=search_ajax&query=" + encodeURIComponent(query))
                    .then(response => {
                        if (response.ok) {
                            return response.text();
                        } else {
                            throw new Error('Error en la petición AJAX');
                        }
                    })
                    .then(text => {
                        searchResults.innerHTML = text;
                        searchResults.style.display = "block";
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    });
            }, 300);
        } else {
            searchResults.innerHTML = "";
        }
    });

    swiperJText.on('init', updateActiveDotColor);

    swiperJText.on('slideChange', updateActiveDotColor);

    updateActiveDotColor();

    const tabLinks = document.querySelectorAll(".tab-link");
    const tabContents = document.querySelectorAll(".slider-tabs-content");

    tabLinks.forEach((tab, index) => {
        tab.addEventListener("click", (e) => {
            e.preventDefault();

            tabLinks.forEach(link => link.classList.remove("active"));
            tabContents.forEach(content => content.classList.add("hidden"));

            tab.classList.add("active");
            tabContents[index].classList.remove("hidden");
        });
    });

    const sliderTabsC = document.querySelectorAll(".slider-tabs");

    sliderTabsC.forEach(slider => {
        const swiperWrapper = slider.querySelector(".swiper-wrapper");
        const slides = swiperWrapper.querySelectorAll(".swiper-slide");

        if (slides.length < 4) {
            swiperWrapper.classList.add("justify-center");
        } else {
            swiperWrapper.classList.remove("justify-center");
        }
    });

    swiperJelly.controller.control = swiperJText;
    swiperJelly2.controller.control = swiperJText2;
    swiperMain.controller.control = swiperText;
});